module.exports = __webpack_public_path__ + "img/kslab-logo.83003a9a.png";